import { Dropdown as AntdDropdown } from "antd";
import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const Dropdown = ({
  children,
  placement = "bottomRight",
  items,
  onClick,
  overlayClassName = "",
  selectedKeys,
  multiple = false,
  trigger = ["click"],
  ...rest
}) => {
  return (
    <AntdDropdown
      {...rest}
      menu={{ items, onClick, selectedKeys }}
      placement={placement}
      multiple={multiple}
      trigger={trigger}
      overlayClassName={classNames(styles.container, overlayClassName)}
    >
      {children}
    </AntdDropdown>
  );
};

export default Dropdown;
